const api_endpoint = process.env.NODE_ENV === 'production' ? "https://api.torgyd.com" : "http://localhost:8000";
export default api_endpoint;